import React from 'react';
import { useTranslations } from 'next-intl';
import { H2 } from './styleConstants';
import { Container } from '..';
import { CustomImage as Image } from '..';
import styles from './InfoCardsGrid.module.css';
// import { getCompressedAssetUrl } from 'lib/config/assetUrls';

type CardContent = {
  id: string;
  titleKey: string;
  descriptionKey: string;
  image: string;
  blendMode?: React.CSSProperties['mixBlendMode'];
};

const cardItems: CardContent[] = [
  {
    id: 'sleep',
    titleKey: 'healthStack.cards.sleep.title',
    descriptionKey: 'healthStack.cards.sleep.description',
    image: 'web_v2/partners/partners-benefits/Sleep.png',
  },
  // {
  //   title: 'Activity & Performance',
  //   description:
  //     'Monitor movement, training load, and physiological adaptation to optimise performance, guide training decisions, and reduce the risk of injury or overtraining.',
  //   image: 'web_v2/partners/partners-benefits/Activity-v2.png',
  // },
  {
    id: 'performance',
    titleKey: 'healthStack.cards.performance.title',
    descriptionKey: 'healthStack.cards.performance.description',
    image: 'web_v2/partners/partners-benefits/activity-performance.png',
  },
  {
    id: 'respiratory',
    titleKey: 'healthStack.cards.respiratory.title',
    descriptionKey: 'healthStack.cards.respiratory.description',
    image: 'web_v2/partners/partners-benefits/Respiratory.png',
  },
  {
    id: 'cardiovascular',
    titleKey: 'healthStack.cards.cardiovascular.title',
    descriptionKey: 'healthStack.cards.cardiovascular.description',
    image: 'web_v2/partners/partners-benefits/Cardiovascular.png',
  },
  {
    id: 'metabolic',
    titleKey: 'healthStack.cards.metabolic.title',
    descriptionKey: 'healthStack.cards.metabolic.description',
    image: 'web_v2/partners/partners-benefits/Metabolic-v2.png',
  },
  {
    id: 'womens',
    titleKey: 'healthStack.cards.womens.title',
    descriptionKey: 'healthStack.cards.womens.description',
    image: 'web_v2/partners/partners-benefits/Womens-health.png',
  },
];

export const InfoCardsGrid = ({ className }: { className?: string }) => {
  const t = useTranslations('partners');
  return (
    <section
      className={`${styles.root}${className ? ` ${className}` : ''}`}
    >
      <Container className={styles.container}>
        <div className={styles.textContent}>
          <H2 className={styles.h2White} style={{ marginBottom: '12px' }}>
            {t('healthStack.title')}
          </H2>
          {/* <Subtitle style={{ margin: '0 auto' }}>
            Ultrahuman Home and Ring AIR work together through UltraSync,
            correlating how your environment and physiology impact your sleep
            and recovery.
          </Subtitle> */}
        </div>

        <div className={styles.grid} role="list" aria-label={t('healthStack.listAriaLabel')}>
          {cardItems.map((item) => (
            <article
              className={styles.darkCard}
              key={item.id}
              role="listitem"
            >
              <div className={styles.cardAsset}>
                <Image
                  className={styles.cardImage}
                  src={item.image}
                  alt={t(item.titleKey)}
                  style={
                    {
                      '--blend-mode': item.blendMode ?? 'normal',
                    } as React.CSSProperties
                  }
                  width={800}
                  height={600}
                />
              </div>
              <div className={styles.cardText}>
                <h3 className={styles.cardTitle}>
                  {t(item.titleKey)}
                </h3>
                <p className={styles.cardSubtitle}>{t(item.descriptionKey)}</p>
              </div>
            </article>
          ))}
        </div>
      </Container>
    </section>
  );
};
